export default __webpack_public_path__ + "static/redis-2c4b12807d9ed77302d9c450fe28636b.svg";